import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

// Components 
 
import Action from '../../header/Action';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import Box from '@mui/material/Box';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

const NoteDropdown: React.FC = () => {

    const colors = useAppSelector(state => state.theme.colors);

    // -- 

    return ( 

        <Box
            sx={{ 
                display: 'flex', 
                flexDirection: 'row',
                alignItems: 'center', 
                justifyContent: 'space-evenly',
                width: 200,
                height: 'auto',
                top: 50, 
                right: 20, 
                position: 'absolute',
                backgroundColor: colors?.fileExplorerDropdown,
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                borderRadius: 4,
                zIndex: 10000, 
                transition: 'width 0.3s',
            }}
        >

            <Box
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    width: '100%', 
                    cursor: 'pointer',
                }}
            >

                <Action title={'viewNote'} action={'viewNote'} type='dropdown'>
                    <RemoveRedEyeOutlinedIcon /> 
                </Action>

                <Action title={'editNote'} action={'editNote'} type='dropdown'>
                    <DriveFileRenameOutlineIcon /> 
                </Action>

                <Action title={'removeNote'} action={'removeNote'} type='dropdown'>
                    <DeleteOutlineIcon /> 
                </Action>

            </Box>

        </Box>

    )

}; 

export default NoteDropdown; 